<template>
    <vx-card :title='$t("PeriodsTable")'>

        <vs-table ref="table" v-model="selected" @selected="handleSelected" pagination :max-items="50" search :data="periods">

            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                <div v-if="$checkPermission(1601)" class="flex flex-wrap-reverse items-center">
                    <vs-button type="border" color="success" icon-pack="feather" icon="icon-plus-circle" @click="addPeriodPrompt = true">{{$t("Add")}}</vs-button>
                </div>

                <vs-dropdown v-if="periods" vs-trigger-click class="cursor-pointer mb-4 mr-4">
                    <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                        <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ periods.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : periods.length }} of {{ periods.length }}</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>

                    <vs-dropdown-menu>

                        <vs-dropdown-item @click="itemsPerPage=10">
                            <span>10</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=20">
                            <span>20</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=50">
                            <span>50</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=100">
                            <span>100</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </div>

            <template slot="thead">
                <vs-th sort-key="start_kilometers">{{$t("StartKilometers")}}</vs-th>
                <vs-th sort-key="end_kilometers">{{$t("EndKilometers")}}</vs-th>
                <vs-th sort-key="start">{{$t("StartTime")}}</vs-th>
                <vs-th sort-key="end">{{$t("EndTime")}}</vs-th>
                <vs-th sort-key="status">{{$t("Status")}}</vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                    <vs-td :data="data[index].start_kilometers">
                        {{ data[index].start_kilometers }}
                    </vs-td>

                    <vs-td :data="data[index].end_kilometers">
                        {{ data[index].end_kilometers }}
                    </vs-td>

                    <vs-td :data="data[index].start">
                        {{moment(data[index].start).format('DD/MM/YYYY')}}
                    </vs-td>

                    <vs-td :data="data[index].end">
                        {{moment(data[index].end).format('DD/MM/YYYY')}}
                    </vs-td>

                    <vs-td :data="data[index].status">
                        <vs-chip v-if="data[index].status === 0" color="#34495e">
                            {{$t("Waiting")}}
                        </vs-chip>
                        <vs-chip v-else-if="data[index].status === 1" color="#f1c40f">
                            {{$t("CandidateGeneration")}}
                        </vs-chip>
                        <vs-chip v-else-if="data[index].status === 2" color="#9b59b6">
                            {{$t("BranchOfficePlacement")}}
                        </vs-chip>
                        <vs-chip v-else-if="data[index].status === 3" color="#3498db">
                            {{$t("TravelOrderGeneration")}}
                        </vs-chip>
                        <vs-chip v-else-if="data[index].status === 4" color="#2ecc71">
                            {{$t("Finished")}}
                        </vs-chip>
                        <vs-chip v-else-if="data[index].status === 5" color="#e74c3c">
                            {{$t("GenerationFailed")}}
                        </vs-chip>
                    </vs-td>


                </vs-tr>
                </tbody>
            </template>

        </vs-table>

        <vs-popup :title="$t('Add')" :active.sync="addPeriodPrompt">
            <div>
                <p class="mt-6">{{$t("StartKilometers")}}</p>
                <vs-input v-model="addPeriodObject['start_kilometers']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("EndKilometers")}}</p>
                <vs-input v-model="addPeriodObject['end_kilometers']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("StartTime")}}</p>
                <flat-pickr :config="configDateTimePicker" v-model="addPeriodObject['start']"/>
                <p class="mt-6">{{$t("EndTime")}}</p>
                <flat-pickr :config="configDateTimePicker" v-model="addPeriodObject['end']"/>
                <vs-divider/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="addPeriod">{{$t("Add")}}</vs-button>
            </div>
        </vs-popup>
    </vx-card>
</template>
<script>

    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    export default {
        components: {
            flatPickr,
        },
        props: {
            vehicleId: {
                type: Number,
                required: true
            },
        },
        data() {
            return {
                periods: null,

                selected: {},
                itemsPerPage: 20,
                isMounted: false,

                addPeriodPrompt: false,
                addPeriodObject: {},

                configDateTimePicker: {
                    dateFormat: 'Y-m-d',
                    locale: {
                        firstDayOfWeek: 1
                    }
                },
            }
        },
        computed: {
            currentPage() {
                if(this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
        },
        methods: {
            handleSelected(tr) {
                if(!this.$checkPermission(1601)) return;
                this.$router.push(
                    {
                        name: 'atPeriod',
                        params:
                            {
                                id: tr.id,
                                vehicle_id: this.vehicleId
                            }
                });
            },
            updatePeriods() {
                const thisIns = this;
                this.$http.get('/api/artificial_transport/v1/vehicle/' + this.vehicleId + '/period')
                    .then(function (response) {
                        thisIns.periods = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            addPeriod() {
                const thisIns = this;
                this.$http.post('/api/artificial_transport/v1/vehicle/' + this.vehicleId + '/period', {
                    start_kilometers: Number(this.addPeriodObject.start_kilometers),
                    end_kilometers: Number(this.addPeriodObject.end_kilometers),
                    start: this.moment(this.addPeriodObject.start).format(),
                    end: this.moment(this.addPeriodObject.end).add(1, 'd').subtract(1, 'ms').format(),
                })
                 .then(function () {
                     thisIns.addPeriodPrompt = false;
                    thisIns.updatePeriods();
                    this.addPeriodObject = {}
                }).catch(function (error) {
                    thisIns.addPeriodPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            }
        },
        created() {
            this.updatePeriods();
        },
        mounted() {
            this.isMounted = true;
        },
        beforeRouteLeave (to, from, next) {
            if(this.addPeriodPrompt){
                this.addPeriodPrompt = false;
                next(false)
            }else{
                next()
            }
        }
    }

</script>
